import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../ContextMenu/ContextMenu.module.css'
import { addFiducialPoint, removeFiducialPoint, updateFiducialPointContext, selectCurrentFiducialPoints } from '../../AnnotatorSlice'
import { FIDUCIAL_POINT_TYPES } from '../../../../constants/annotator'

const FiducialPointContextMenu = () => {
    const dispatch = useDispatch()
    const fiducialPointContext = useSelector((state) => state.Annotator.fiducialPointContext)
    const existingPoints = useSelector(selectCurrentFiducialPoints)

    const { top = 0, left = 0, sampleIndex = null, offsetMs = null, existingType = null } = fiducialPointContext.data

    if (!fiducialPointContext.show) return null

    const addFiducialPointType = (type) => {
        dispatch(addFiducialPoint({ type, offsetMs: offsetMs ?? 0 }))
        dispatch(updateFiducialPointContext({
            show: false,
            data: { top: 0, left: 0, sampleIndex: null, offsetMs: null, existingType: null }
        }))
    }

    const deleteFiducialPoint = (type) => {
        dispatch(removeFiducialPoint(type))
        dispatch(updateFiducialPointContext({
            show: false,
            data: { top: 0, left: 0, sampleIndex: null, offsetMs: null, existingType: null }
        }))
    }

    const closeMenu = () => {
        dispatch(updateFiducialPointContext({
            show: false,
            data: { top: 0, left: 0, sampleIndex: null, offsetMs: null, existingType: null }
        }))
    }

    return (
        <div
            id="fiducialPointContextMenu"
            style={{ top: top, left }}
            className={styles.dropdownContent}
            onContextMenu={(e)=>{e.preventDefault()}}
        >
            {FIDUCIAL_POINT_TYPES.map((fpType) => {
                const isAlreadySet = existingPoints.some(p => p.type === fpType.slug)
                // When right-clicked near an existing point, don't offer to
                // add other types — only allow deleting the nearby point.
                if (existingType && existingType !== fpType.slug) return null
                // Otherwise, hide types that are already placed elsewhere.
                if (isAlreadySet && existingType !== fpType.slug) return null
                const isExisting = existingType === fpType.slug
                return (
                    <a
                        key={fpType.slug}
                        href="#"
                        style={{
                            backgroundColor: fpType.color,
                            color: '#fff',
                        }}
                        onClick={(e) => {
                            e.preventDefault()
                            addFiducialPointType(fpType.slug)
                        }}
                    >
                        {fpType.name}
                    </a>
                )
            })}
            {existingType && (
                <a
                    href="#"
                    style={{ backgroundColor: '#aa2e25', color: '#fff' }}
                    onClick={(e) => {
                        e.preventDefault()
                        deleteFiducialPoint(existingType)
                    }}
                >
                    Delete
                </a>
            )}
            <a
                href="#"
                style={{ backgroundColor: '#666', color: '#fff' }}
                onClick={(e) => {
                    e.preventDefault()
                    closeMenu()
                }}
            >
                Cancel
            </a>
        </div>
    )
}

export default FiducialPointContextMenu